/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Adr_Preview_TitleInputs */



/**
* | output |
* | --- |
* | "ADR Preview Setup" |
*
* @param {Options_Adr_Preview_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_adr_preview_title = /** @type {((inputs?: Options_Adr_Preview_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Adr_Preview_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Configuration de l'aperçu ADR")
	if (locale === "de") return /** @type {LocalizedString} */ ("ADR-Vorschau-Setup")
	if (locale === "it") return /** @type {LocalizedString} */ ("Configurazione dell'anteprima ADR")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Предварительный просмотр ADR")
	if (locale === "es") return /** @type {LocalizedString} */ ("Configuración de vista previa de ADR")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("ADR预览设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ADRプレビュー設定")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एडीआर पूर्वावलोकन सेटअप")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Configuração de pré-visualização de ADR")
	return /** @type {LocalizedString} */ ("ADR Preview Setup")
});